import ChatBot from './ChatBot.vue'

export default ChatBot
